import React from 'react';
import './AnnouncementBanner.css';

export default function AnnouncementBanner() {
  const message = '🚀 Sculpit is currently under development. The full product will be publicly available by the end of 2026 or Q1 2027. Stay tuned!';

  return (
    <div className="announcement-banner">
      <div className="announcement-banner__track">
        <span className="announcement-banner__text">{message}</span>
        <span className="announcement-banner__text">{message}</span>
      </div>
    </div>
  );
}
